<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">

          <div class=" col-lg-12 col-md-12 col-12" v-if="user.role === '3'">
            <div>
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <router-link :to="{ name: 'Production' }" class="card-link">
              <card :title="stats.projects.title" :value="stats.projects.value" :percentage="stats.projects.percentage"
                :iconClass="stats.projects.iconClass" :iconBackground="stats.projects.iconBackground" directionReverse>
              </card>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <router-link :to="{ name: 'Users' }" class="card-link">
              <card :title="stats.users.title" :value="stats.users.value" :percentage="stats.users.percentage"
                :iconClass="stats.users.iconClass" :iconBackground="stats.users.iconBackground" directionReverse></card>
            </router-link>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1'">
            <router-link :to="{ name: 'Payment' }" class="card-link" v-if="license && license.status">
              <card :title="'Licencia'" :value="license.status === 'paid' ? 'Pagado' :
                license.status === 'pending' ? 'Pendiente' :
                  license.status === 'rejected' ? 'Rechazado' :
                    license.status === 'voided' ? 'Anulado' : 'Validando...'"
                :percentage="license.coverage_month ? new Date(license.coverage_month).toLocaleDateString('es-ES') : 'N/A'" :iconClass="'fa fa-id-card'"
                :iconBackground="'bg-gradient-dark'" :valueColor="getStatusColor(license.status)"
                :percentageColor="getStatusColor(license.status)" directionReverse></card>
            </router-link>
          </div>

        </div>
        <div class="row" v-if="user.role === '1' || user.role === '2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
            <div class="card">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5" hidden>
            <carousel />
          </div>
        </div>

        <!-- ---Sección de tareas y producción--- -->
        <div class="row mt-4" v-if="user.role === '1' || user.role === '2'">

          <!-- Tabla de tareas sin entregar -->
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Tareas Sin Entregar</h6>
                </div>
                <div class="d-flex align-items-stretch mt-2">
                  <!-- Input de búsqueda -->
                  <input type="text" v-model="searchQuery" class="form-control"
                    placeholder="Buscar número de producción o usuario..." style="width:85%;">

                  <!-- Filtro -->
                  <div ref="undeliveredDropdown" class="dropdown ms-2" style="width:15%;"
                    :class="{ show: isFilterOpen }">
                    <button class="form-control dropdown-toggle h-100 d-flex justify-content-center align-items-center"
                      type="button" id="filterDropdown" @click="toggleFilter" :aria-expanded="isFilterOpen">
                      <i class="fa fa-filter"></i>
                    </button>

                    <ul class="dropdown-menu w-10" :class="{ show: isFilterOpen }" style="min-width:6rem; width:6rem;">
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Todos')">Todos</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Mensualidad')">Mes</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Tarea')">Tarea</a></li>
                    </ul>

                  </div>
                </div>
              </div>



              <div class="table-responsive" style="overflow: scroll; max-height: 500px;">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(value, index) in filteredUndelivered" :key="index"
                      @click="redirectToProduction(value.production)" style="cursor: pointer;">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Producción:</p>
                            <h6 class="mb-0 text-sm">
                              #{{ value.production.id }} - {{ value?.production?.name ?? "No encontrada" }}
                            </h6>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Usuario:</p>
                          <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>

                          <span class="badge badge-sm"
                            :class="value.user?.payment === 0 ? 'bg-gradient-info' : 'bg-gradient-success'">
                            {{ value.user?.payment === 0 ? 'Mensualidad' : 'Tarea' }}
                          </span>

                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">Días:</p>
                          <span :class="{
                            'badge bg-secondary text-light': value.days_since_delivered < 8,
                            'badge bg-warning text-light': value.days_since_delivered >= 8 && value.days_since_delivered <= 15,
                            'badge bg-danger': value.days_since_delivered > 15
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Fecha de asignación:</p>
                          <h6 class="mb-0 text-sm">
                            {{ isValidDate(value.assigned_at) ? new Date(value.assigned_at).toLocaleDateString('es-ES')
                              : 'Sin asignar' }}
                          </h6>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="filteredUndelivered.length == 0">
                      <td class="text-center" colspan="4">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de tareas sin validar -->
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Tareas Entregadas Sin Validar</h6>
                </div>
                <div class="d-flex align-items-stretch mt-2">
                  <!-- Input de búsqueda -->
                  <input type="text" v-model="searchQueryUnvalidated" class="form-control"
                    placeholder="Buscar número de producción o usuario..." style="width:85%;">

                  <!-- Nuevo Filtro -->
                  <div ref="unvalidatedDropdown" class="dropdown ms-2" style="width:15%;"
                    :class="{ show: isFilterUnvalidatedOpen }">
                    <button class="form-control dropdown-toggle h-100 d-flex justify-content-center align-items-center"
                      type="button" @click="toggleUnvalidatedFilter" :aria-expanded="isFilterUnvalidatedOpen">
                      <i class="fa fa-filter"></i>
                    </button>

                    <ul class="dropdown-menu w-100" :class="{ show: isFilterUnvalidatedOpen }"
                      style="min-width:6rem; width:6rem;">
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Todos')">Todos</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Mensualidad')">Mes</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Tarea')">Tarea</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="table-responsive" style="overflow: scroll; max-height: 500px;">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(value, index) in filteredUnvalidated" :key="index"
                      @click="redirectToProduction(value.production)" style="cursor: pointer;">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Producción:</p>
                            <h6 class="mb-0 text-sm">
                              #{{ value.production.id }} - {{ value?.production?.name ?? "No encontrada" }}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Usuario:</p>
                          <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                          <span class="badge badge-sm"
                            :class="value.user?.payment === 0 ? 'bg-gradient-info' : 'bg-gradient-success'">
                            {{ value.user?.payment === 0 ? 'Mensualidad' : 'Tarea' }}
                          </span>

                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">Días:</p>
                          <span :class="{
                            'badge bg-danger': value.days_since_delivered > 2,
                            'badge bg-secondary': value.days_since_delivered <= 2
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Fecha de asignación:</p>
                          <h6 class="mb-0 text-sm">{{ new Date(value.received_date).toLocaleDateString('es-ES') }}</h6>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="filteredUnvalidated.length == 0">
                      <td class="text-center" colspan="4">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de producción -->
          <div class="col-lg-12 mt-4 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Producción Activa</h6>
                </div>
                <!-- Input de búsqueda -->
                <input type="text" v-model="searchQueryProduction" class="form-control mt-2"
                  placeholder="Buscar producción...">
              </div>

              <div class="table-responsive" style="overflow: scroll; max-height: 500px;">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(value, index) in filteredProduction" :key="index" @click="redirectToProduction(value)"
                      style="cursor: pointer;">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Producción:</p>
                            <h6 class="mb-0 text-sm">#{{ value.id }} - {{ value.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">Días restantes:</p>
                          <span :class="{
                            'badge bg-danger': value.days_since_delivered < 0,
                            'badge bg-secondary': value.days_since_delivered > 2
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Fecha de Entrega:</p>
                          <h6 class="mb-0 text-sm">{{ new Date(value.delivery_date +
                            'T00:00:00').toLocaleDateString('es-ES') }}</h6>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="filteredProduction.length == 0">
                      <td class="text-center" colspan="3">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de producción terminada -->
          <div class="col-lg-12 mt-4 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Producción Terminada</h6>
                </div>
                <!-- Input de búsqueda -->
                <input type="text" v-model="searchQueryProductionFinish" class="form-control mt-2"
                  placeholder="Buscar producción...">
              </div>
              <div class="table-responsive" style="overflow: scroll; max-height: 500px;">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(value, index) in filteredProductionFinish" :key="index"
                      @click="redirectToProduction(value)" style="cursor: pointer;">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Producción:</p>
                            <h6 class="mb-0 text-sm">#{{ value.id }} - {{ value.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Fecha de Creación:</p>
                          <h6 class="mb-0 text-sm">{{ new Date(value.delivery_date +
                            'T00:00:00').toLocaleDateString('es-ES') }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Fecha de Entrega:</p>
                          <h6 class="mb-0 text-sm">{{ new Date(value.created_at).toLocaleDateString('es-ES') }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Diferencia:</p>
                          <h6 class="mb-0 text-sm">

                            {{ value.time_difference }}


                          </h6>
                        </div>
                      </td>


                    </tr>
                    <tr v-if="filteredProduction.length == 0">
                      <td class="text-center" colspan="3">
                        <p>No hay registros</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>







      </div>
    </div>
  </div>
</template>

<style scoped>
.dropdown-toggle::after {
  display: none !important;
}
</style>
<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      searchQuery: '',
      searchQueryUnvalidated: '',
      searchQueryProduction: '',
      searchQueryProductionFinish: '',
      stats: {
        projects: {
          title: "Producción activa",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-folder-17",
          detail: "since yesterday",
          iconBackground: "bg-gradient-info",
        },
        users: {
          title: "Usuarios",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
      },
      user: {},
      undelivered: [],
      unvalidated: [],
      production: [],
      productionFinish: [],
      license: {
        status: null,
        coverage_month: null
      },
      filterType: 'Todos',
      isFilterOpen: false,
      filterTypeUnvalidated: 'Todos',
      isFilterUnvalidatedOpen: false,
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
  },
  computed: {

    filteredUndelivered() {
      // si no hay texto ni filtro → muestra todo
      if (!this.searchQuery && this.filterType === 'Todos') return this.undelivered;

      const q = this.searchQuery.toLowerCase();

      return this.undelivered.filter(value => {
        /* -------- filtro por tipo -------- */
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterType !== 'Todos' && tipo !== this.filterType) return false;

        /* -------- filtro por búsqueda -------- */
        if (!q) return true;   // solo filtraba por tipo

        const productionId = value.production.id.toString().toLowerCase();
        const userName = value.user.name.toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredUnvalidated() {
      // Filtrado combinado de búsqueda y tipo
      const q = this.searchQueryUnvalidated.toLowerCase();

      return this.unvalidated.filter(value => {
        // Filtro por tipo
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterTypeUnvalidated !== 'Todos' && tipo !== this.filterTypeUnvalidated) return false;

        // Filtro por búsqueda
        if (!q) return true;

        const productionId = value.production.id.toString().toLowerCase();
        const userName = value.user.name.toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredProduction() {
      if (!this.searchQueryProduction) return this.production;

      return this.production.filter(value => {
        const productionId = value.id.toString().toLowerCase();
        const productionName = value.name.toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    },
    filteredProductionFinish() {
      if (!this.searchQueryProductionFinish) return this.productionFinish;

      return this.productionFinish.filter(value => {
        const productionId = value.id.toString().toLowerCase();
        const productionName = value.name.toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    }
  },
  methods: {
    redirectToProduction(value) {
      this.$router.push({
        name: 'Production Create',
        params: { data: JSON.stringify(value) }
      });
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async fetchAnalytics() {
      await this.$store.dispatch('analitycs/getCards');
      this.stats = this.$store.state.analitycs.cards;
    },
    async fetchUndelivered() {
      let datos = await this.$store.dispatch('analitycs/getUndelivered');
      this.undelivered = datos.data;
    },
    async fetchUnvalidated() {
      let datos = await this.$store.dispatch('analitycs/getUnvalidate');
      this.unvalidated = datos.data;
    },
    async fetchProduction() {
      let datos = await this.$store.dispatch('analitycs/getProduction');
      this.production = datos.data;
    },
    async fetchProductionFinish() {
      let datos = await this.$store.dispatch('analitycs/getProductionFinish');
      this.productionFinish = datos.data;
    },
    async fetchLicense() {
      this.license = await this.$store.dispatch('payments/get');
      console.log(this.license);
    },
    getStatusColor(status) {
      if (!status) return 'text-secondary';
      switch (status) {
        case 'paid':
          return 'text-success';  // Color verde para "Pagado"
        case 'pending':
          return 'text-warning';  // Color amarillo para "Pendiente"
        case 'rejected':
          return 'text-danger';   // Color rojo para "Rechazado"
        case 'voided':
          return 'text-muted';    // Color gris para "Anulado"
        default:
          return 'text-secondary'; // Color por defecto
      }
    },
    /* ---------- filtros ---------- */
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.isFilterUnvalidatedOpen = false;
    },
    toggleUnvalidatedFilter() {
      this.isFilterUnvalidatedOpen = !this.isFilterUnvalidatedOpen;
      this.isFilterOpen = false;
    },
    /* seleccionar opción y cerrar */
    setFilter(tipo) {
      this.filterType = tipo;
      this.isFilterOpen = false;
    },
    setFilterUnvalidated(tipo) {
      this.filterTypeUnvalidated = tipo;
      this.isFilterUnvalidatedOpen = false;
    },
    /* click fuera */
    onClickOutside(e) {
      if (
        this.isFilterOpen &&
        this.$refs.undeliveredDropdown &&
        !this.$refs.undeliveredDropdown.contains(e.target)
      ) {
        this.isFilterOpen = false;
      }
      if (
        this.isFilterUnvalidatedOpen &&
        this.$refs.unvalidatedDropdown &&
        !this.$refs.unvalidatedDropdown.contains(e.target)
      ) {
        this.isFilterUnvalidatedOpen = false;
      }
    },

  },
  mounted() {
    document.addEventListener("click", this.onClickOutside);


    let user = JSON.parse(localStorage.getItem('user'));
    this.user = user;

    // Redirigir operadores a su dashboard
    if (user && user.role === '3') {
      this.$router.push({ name: 'Operador Dashboard' });
      return;
    }

    if (user.role === '1' || user.role === '2') {
      this.fetchAnalytics();
      this.fetchUndelivered();
      this.fetchUnvalidated();
      this.fetchProduction();
      this.fetchProductionFinish();
      this.fetchLicense();
    }


  },
  beforeUnmount() {
    document.removeEventListener("click", this.onClickOutside);
  },
};
</script>
